import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Enfermagem } from 'src/app/models/operacao/enfermagem.model';
import { URL_GLOBAL, URL_WEB } from 'src/environments/environment';
import { CacheService } from '../cache/cache.service';
import { AuthService } from '../vos/auth.service';
import { generateQueryString } from 'src/app/shared/funcoes';

type DashboardServiceRequestParams = {
  tab: 'client' | 'professional' | 'general';
  query?: {
    start_date: string;
    end_date: string;
  };
};

@Injectable({
  providedIn: 'root',
})
export class EscalaService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private cacheService: CacheService
  ) { }

  deleteEnfermagem(id: any): Observable<any> {
    return this.http.delete<any>(`${`${URL_GLOBAL}/escalas`}/${id}`, {
      headers: this.authService.userToken(),
    });
  }
  saveEnfermagem(data: any): Observable<Enfermagem> {
    return this.http.post<any>(`${URL_GLOBAL}/escalas`, data, {
      headers: this.authService.userToken(),
    });
  }

  postScales(data: any, aux: boolean) {
    return this.http
      .post(
        `${URL_GLOBAL}/${aux ? 'new-flow' : 'old-flow'}/create-scales`,
        data,
        { headers: this.authService.userToken() }
      )
      .toPromise();
  }
  // Modal Editar Ponto
  updateEnfermagem(id: any, data: any): Observable<Enfermagem> {
    return this.http.put<any>(`${URL_GLOBAL}/escalas/${id}`, data, {
      headers: this.authService.userToken(),
    });
  }
  dashboardClonarEscalas(data): Observable<Enfermagem> {
    return this.http.post<any>(
      `${URL_GLOBAL}/web/escalas/dashboardClonarEscalas`,
      data,
      { headers: this.authService.userToken() }
    );
  }

  BuscaEscalasPorPacienteEPeriodoDeDatas(
    idContrato: string,
    diaInicio: string,
    diaFim: string
  ): Observable<any> {
    return this.http.get(
      `${`${URL_GLOBAL}/escalas`}/escalas/paciente/${idContrato}/data-inicio/${diaInicio}/data-fim/${diaFim}`
    );
  }

  PegarTodosOsRegistrosPorIdDaEmpresa(
    param: any,
    token: any
  ): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/escalas/dashboard?ordemservico_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}&supervisor=${param.supervisor == true ? true : ''
      }&cliente_id=${param.cliente_id ? param.cliente_id : ''}`,
      { headers }
    );
  }
  PegarTodosOsRegistrosPorIdDaEmpresaScale(
    param: any,
    token: any
  ): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/escalas/dashboard?ordemservico_id=${param.ordemservico ? param.ordemservico : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}&supervisor=${param.supervisor == true ? true : ''
      }&cliente_id=${param.cliente_id ? param.cliente_id : ''}`,
      { headers }
    );
  }

  PegarTodosOsRegistrosPorIdDaEmpresa2(
    url: string,
    param: any,
    token: any
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any>(
      url
        ? `${url}&ordemservico_id=${param.paciente ? param.paciente : ''
        }&data_ini=${param.dataInicio}&data_fim=${param.dataFim
        }&prestador_id=${param.prestador_id ? param.prestador_id : ''
        }&servico_id=${param.especialidade ? param.especialidade : ''
        }&supervisor=${param.supervisor == true ? true : ''}&cliente_id=${param.cliente_id ? param.cliente_id : ''
        }${!param.status ? '&status=' + !param.status : ''}`
        : `${URL_GLOBAL}/web/escalas/dashboard-life?ordemservico_id=${param.paciente ? param.paciente : ''
        }&data_ini=${param.dataInicio}&data_fim=${param.dataFim
        }&prestador_id=${param.prestador_id ? param.prestador_id : ''
        }&servico_id=${param.especialidade ? param.especialidade : ''
        }&supervisor=${param.supervisor == true ? true : ''}&cliente_id=${param.cliente_id ? param.cliente_id : ''
        }${!param.status ? '&status=' + !param.status : ''}`,
      { headers }
    );
  }

  // Area do Responsavel
  listEscalasByIdResponsavel(param) {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/responsavel/escalas/listEscalasByIdResponsavel?datainicio=${param.datainicio}&datafim=${param.datafim}`,
      { headers: this.authService.userToken() }
    );
  }
  listEscalasAssinadasByIdResponsavel(param) {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/responsavel/escalas/listEscalasAssinadasByIdResponsavel?datainicio=${param.datainicio}&datafim=${param.datafim}`,
      { headers: this.authService.userToken() }
    );
  }
  find(id: any): Observable<any> {
    return this.http.get(`${`${URL_GLOBAL}/escalas`}/${id}`);
  }
  findComAutenticacao(id: any): Observable<any> {
    return this.http.get(`${`${URL_GLOBAL}/escalas`}/${id}`, {
      headers: this.authService.userToken(),
    });
  }
  assinar(data: any): Observable<any> {
    return this.http.post<any>(
      `${URL_GLOBAL}/web/responsavel/escalas/assinar`,
      data,
      { headers: this.authService.userToken() }
    );
  }
  buscaRelatorios(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/relatorioDiario?ordemservico_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador ? param.prestador : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  responsavelBuscaRelatorios(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/responsavel/dashboard/relatorioDiario?ordemservico_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador ? param.prestador : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  buscaProdutividade(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/relatorioProdutividade?ordemservico_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador ? param.prestador : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  buscaMedicamentos(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/relatorioMedicamento?ordemservico_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  responsavelbuscaProdutividade(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/responsavel/dashboard/relatorioProdutividade?ordemservico_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  listEscalasByIdOrdemServico(ordemservico_id): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/responsavel/escalas/listEscalasByIdOrdemServico/${ordemservico_id}`,
      { headers: this.authService.userToken() }
    );
  }

  dashboardPegarTodosOsRegistrosPorIdDaEmpresa(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/responsavel/escalas/dashboardPegarTodosOsRegistrosPorIdDaEmpresa?ordemservico_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  // Área do Convênio
  convenioPegarTodosOsRegistrosPorIdDaEmpresa(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/convenio/escalas/dashboard?ordemservico_id=${param.paciente}&periodo=${param.periodo}`,
      { headers: this.authService.userToken() }
    );
  }
  convenioBuscaRelatorios(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/convenio/dashboard/relatorioDiario?ordemservico_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  convenioBuscaProdutividade(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/convenio/dashboard/relatorioProdutividade?ordemservico_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  dashboardConvenioPegarTodosOsRegistrosPorIdDaEmpresa(
    param: any
  ): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/convenio/escalas/dashboardPegarTodosOsRegistrosPorIdDaEmpresa?ordemservico_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  // Dashboard Area Clinica
  dashboardTotalProfissionaisEscalasPorPeriodo(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_WEB}/areaClinica/dashboard/dashboardTotalProfissionaisEscalasPorPeriodo?data_ini=${param.dataInicio
      }&data_fim=${param.dataFim}&empresa_id=${param.empresa_id ? param.empresa_id : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }
  dashboardTotalPacientesServicosPorPeriodo(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_WEB}/areaClinica/dashboard/dashboardTotalPacientesServicosPorPeriodo?data_ini=${param.dataInicio
      }&data_fim=${param.dataFim}&empresa_id=${param.empresa_id ? param.empresa_id : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }
  dashboardTotalRelatoriosPorPeriodo(param): Observable<any> {
    return this.http.get<any>(
      `${URL_WEB}/areaClinica/dashboard/dashboardTotalRelatoriosPorPeriodo?data_ini=${param.dataInicio
      }&data_fim=${param.dataFim}&empresa_id=${param.empresa_id ? param.empresa_id : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }
  dashboardTotalProfissionaisCategoriaPorPeriodo(param): Observable<any> {
    return this.http.get<any>(
      `${URL_WEB}/areaClinica/dashboard/dashboardTotalProfissionaisCategoriaPorPeriodo?data_ini=${param.dataInicio
      }&data_fim=${param.dataFim}&empresa_id=${param.empresa_id ? param.empresa_id : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }
  dashboardTotalPacientesAtivosPorPeriodo(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboardTotalPacientesAtivosPorPeriodo?data_ini=${param.dataInicio}&data_fim=${param.dataFim}`,
      { headers: this.authService.userToken() }
    );
  }
  dashboarTotalContratosDesativadosPorPeriodo(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboarTotalContratosDesativadosPorPeriodo?data_ini=${param.dataInicio}&data_fim=${param.dataFim}`,
      { headers: this.authService.userToken() }
    );
  }
  dashboarTotalPacientesPorSupervisor(): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboarTotalPacientesPorSupervisor`,
      { headers: this.authService.userToken() }
    );
  }
  dashboarTotalPacientesPorConvenio(): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboarTotalPacientesPorConvenio`,
      { headers: this.authService.userToken() }
    );
  }
  dashboarPorIdadePacientes(): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboarPorIdadePacientes`,
      { headers: this.authService.userToken() }
    );
  }
  dashboarTotalCheckinCheckout(params: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboarTotalCheckinCheckout?data_ini=${params.dataInicio}&data_fim=${params.dataFim}&servico_id=${params.servico_id}`,
      { headers: this.authService.userToken() }
    );
  }
  dashboarTotalMedicamentos(params: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboardTotalMedicamentos?data_ini=${params.dataInicio}&data_fim=${params.dataFim}&servico_id=${params.servico_id}`,
      { headers: this.authService.userToken() }
    );
  }
  dashboarTotalAtividades(params: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboardTotalAtividades?data_ini=${params.dataInicio}&data_fim=${params.dataFim}&servico_id=${params.servico_id}`,
      { headers: this.authService.userToken() }
    );
  }
  dashboarCidadesMaisAtendidas(): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboarCidadesMaisAtendidas`,
      { headers: this.authService.userToken() }
    );
  }
  dashboarFaltasdeProfissionaisPorOperadora(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboarFaltasdeProfissionaisPorOperadora?data_ini=${param.dataInicio}&data_fim=${param.dataFim}`,
      { headers: this.authService.userToken() }
    );
  }
  dashboarFaltasdeProfissionaisPorEspecialidade(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboarFaltasdeProfissionaisPorEspecialidade?data_ini=${param.dataInicio}&data_fim=${param.dataFim}`,
      { headers: this.authService.userToken() }
    );
  }
  dashboarFaltasdeProfissionaisPorCidades(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/dashboard/dashboarFaltasdeProfissionaisPorCidades?data_ini=${param.dataInicio}&data_fim=${param.dataFim}`,
      { headers: this.authService.userToken() }
    );
  }
  dashboardMapaPacientesPorEspecialidade(): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/recursosHumanos/dashboard/dashboardMapaPacientesPorEspecialidade`,
      { headers: this.authService.userToken() }
    );
  }
  buscalistaescalasmedicao(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/escalas/medicao?ordemservico_id=${param.paciente ? param.paciente.id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&servico_id=${param.especialidades ? param.especialidades : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }
  escalashistoricoEscalasPorPrestadorId(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/escalas/historicoEscalasPorPrestadorId?data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id}`,
      { headers: this.authService.userToken() }
    );
  }

  //Histórico de Escalas
  historicoescala(url): Observable<any[]> {
    return this.http.get<any[]>(
      `${url ? url : `${URL_GLOBAL}/historicos/escalas?page=1`}`,
      { headers: this.authService.userToken() }
    );
  }
  historicoescalaporpacienteid(url, paciente_id?): Observable<any[]> {
    return this.http.get<any[]>(
      `${url
        ? url
        : `${URL_GLOBAL}/web/escalas/historicoescalaporpacienteid?page=1`
      }&ordemservico_id=${paciente_id ? paciente_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  escalasPorPeriodo(params): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/escalas/escalasPorPeriodo?data_ini=${params.dataInicio}&data_fim=${params.dataFim}`,
      { headers: this.authService.userToken() }
    );
  }
  listaescalascalendario(params): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/escalas/listaescalascalendario?data_ini=${params.dataInicio
      }&data_fim=${params.dataFim}&ordemservico_id=${params.ordemservico_id ? params.ordemservico_id : ''
      }`,
      { headers: this.authService.userToken() }
    );
    // return this.http.get<any[]>(`http://api2.madelife.med.br/api/web/escalas/listaescalascalendario?data_ini=${params.dataInicio}&data_fim=${params.dataFim}&ordemservico_id=${params.ordemservico_id ? params.ordemservico_id : ''}`, { headers: this.authService.userToken() })
  }
  clonarEscalas(params): Observable<any> {
    return this.http.get<any>(
      `${URL_GLOBAL}/web/escalas/clonarEscalas?data_ini=${params.dataInicio
      }&ordemservico_id=${params.ordemservico_id ? params.ordemservico_id : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }

  // END POINT
  saveEnfermagemNew(data: any): Observable<Enfermagem> {
    return this.http.post<any>(`${URL_GLOBAL}/newescala`, data, {
      headers: this.authService.userToken(),
    });
  }
  PegarTodosOsRegistrosPorIdDaEmpresaNew(
    param: any,
    token: any
  ): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any[]>(
      `${URL_GLOBAL}/newescalas/dashboard?paciente_id=${param.paciente_id ? param.paciente_id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.service_id ? param.service_id : ''}&empresa_id=${param.empresa_id ? param.empresa_id : ''
      }&contract_id=${param.contract_id ? param.contract_id : ''}&cliente_id=${param.cliente_id ? param.cliente_id : ''
      }`,
      { headers }
    );
  }
  updateEnfermagemNew(id: any, data: any): Observable<Enfermagem> {
    return this.http.put<any>(`${URL_GLOBAL}/newescalas/${id}`, data, {
      headers: this.authService.userToken(),
    });
  }

  listaescalascalendarioNew(params): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/newescalas/listaescalascalendario?data_ini=${params.dataInicio
      }&data_fim=${params.dataFim}&contract_id=${params.contract_id ? params.contract_id : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }

  clonarEscalasNew(params): Observable<any> {
    return this.http.get<any>(
      `${URL_GLOBAL}/newescalas/clonarEscalas?data_ini=${params.dataInicio
      }&contract_id=${params.contract_id ? params.contract_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  clonarEscalasMultiNew(params): Observable<any> {
    return this.http.get<any>(
      `${URL_GLOBAL}/newescalas/clonar-escalas-multi?data_ini=${params.dataInicio
      }&contract_id=${params.contract_id ? params.contract_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  clonarEscalasManual(data): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/newescalas/clone-scale`, data, {
      headers: this.authService.userToken(),
    });
  }

  // MONITORING

  getMonitoringWithFilters(param: any, token: any): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/monitoring/get-monitorings-filters?contract_id=${param.contract_id ? param.contract_id : ''
      }&data_ini=${param.dataInicio ? param.dataInicio : ''}&data_fim=${param.dataFim ? param.dataFim : ''
      }&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}&cliente_id=${param.cliente_id ? param.cliente_id : ''
      }`,
      { headers }
    );
  }
  // MONITORING, FOLGAS/FUROS
  // ROTA PARA LISTAGEM DE ESCALAS EM FOLGAS E MONITORAMENTO
  getScalesWithFilters(param: any, token: any): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/scale/get-scales-filters?contract_id=${param.contract_id ? param.contract_id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}&cliente_id=${param.cliente_id ? param.cliente_id : ''
      }${param.supervisor ? '&supervisor=true' : ''}${param.formacao_id ? '&formacao_id=' + param.formacao_id : ''
      }`,
      { headers }
    );
  }

  getScaleFromReport(contracts, params) {
    const queryString = generateQueryString(params);

    return this.http.post(`${URL_GLOBAL}/web/scale/reports?${queryString}`, {
      contracts
    }, { headers: this.authService.userToken() })
  }
  // END MONITORING FOLGAS/FUROS

  // ROTAS PARA BUSCAR RELATÓRIOS
  getReportsAll(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/reports/get-general-reports?contract_id=${param.contract_id ? param.contract_id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador ? param.prestador : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  getReportsDiaries(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/reports/get-report-diaries?contract_id=${param.contract_id ? param.contract_id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador ? param.prestador : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  getReportsProductivity(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/reports/get-report-productivity?contract_id=${param.contract_id ? param.contract_id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador ? param.prestador : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}${param.eletronic_point ? '&eletronic_point=true' : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }

  getReportsMedications(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/reports/get-report-medications?contract_id=${param.contract_id ? param.contract_id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador ? param.prestador : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  // END

  // ROTAS MEDIÇÃO
  buscalistaescalasmedicaoNew(param): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/newescalas/medicao?contract_id=${param.contract ? param.contract.id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&servico_id=${param.especialidades ? param.especialidades : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }

  // END POINTS BY MODULE RESPONSIBLE
  getScalesByResponsibles(param) {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/responsible/get-scales-responsibles?datainicio=${param.datainicio}&datafim=${param.datafim}`,
      { headers: this.authService.userToken() }
    );
  }

  getScalesWithAssignature(param) {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/responsible/get-scales-assignature-responsibles?datainicio=${param.datainicio}&datafim=${param.datafim}`,
      { headers: this.authService.userToken() }
    );
  }

  getPatientsOfResposible(params: any, url: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${url
        ? url + '&paginate=1'
        : `${URL_GLOBAL}/web/responsible/get-patients-responsibles?paginate=1`
      }&name=${params.name ? params.name : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  getScaleByContract(contract_id): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/responsible/get-scale-contract/${contract_id}`,
      { headers: this.authService.userToken() }
    );
  }

  getDataMonitoringByResponsible(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/responsible/get-scale-monitoring-responsible?contract_id=${param.contract_id ? param.contract_id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}`,
      { headers: this.authService.userToken() }
    );
  }

  reportsByResponsible(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/reports-responsible/get-reports-day?contract_id=${param.contract_id ? param.contract_id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador ? param.prestador : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  reportsProductivityByResponsible(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/reports-responsible/get-report-productivity-responsible?contract_id=${param.contract_id ? param.contract_id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  //

  // Área do Convênio-new
  convenioPegarTodosOsRegistrosPorIdDaEmpresaNew(
    param: any
  ): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/new-convenio/escalas/dashboard?contract_id=${param.paciente}&periodo=${param.periodo}`,
      { headers: this.authService.userToken() }
    );
  }
  convenioBuscaRelatoriosNew(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/new-convenio/dashboard/relatorioDiario?contract_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  convenioBuscaProdutividadeNew(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/new-convenio/dashboard/relatorioProdutividade?contract_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  dashboardConvenioPegarTodosOsRegistrosPorIdDaEmpresaNew(
    param: any
  ): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/new-convenio/escalas/dashboardPegarTodosOsRegistrosPorIdDaEmpresa?contract_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  buscaMedicamentosNew(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/areaClinica/new-dashboard/relatorioMedicamento?contract_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  //

  getScaleByOrdemServico(param: any, token: any): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/monitoring/get-scales-by-ordem-servico?ordemservico_id=${param.paciente ? param.paciente : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}&supervisor=${param.supervisor == true ? true : ''
      }&cliente_id=${param.cliente_id ? param.cliente_id : ''}`,
      { headers }
    );
  }
  getScaleByContractId(param: any, token: any): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token.access_token,
    });
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/monitoring/get-scales-by-contract?contract_id=${param.contract_id ? param.contract_id : ''
      }&data_ini=${param.dataInicio}&data_fim=${param.dataFim}&prestador_id=${param.prestador_id ? param.prestador_id : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}&supervisor=${param.supervisor == true ? true : ''
      }&cliente_id=${param.cliente_id ? param.cliente_id : ''}`,
      { headers }
    );
  }

  getReportsWithoutPatient(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/reports/get-report-without-patient?data_ini=${param.dataInicio
      }&data_fim=${param.dataFim}&prestador_id=${param.prestador ? param.prestador : ''
      }&servico_id=${param.especialidade ? param.especialidade : ''
      }&empresa_id=${param.empresa_id ? param.empresa_id : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  getCooperativeReport(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/reports/get-report-cooperative?cooperative_id=${param.cooperative_id ? param.cooperative_id : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }
  getDaysOfScale(param: any): Observable<any[]> {
    return this.http.post<any[]>(
      `${URL_GLOBAL}/web/escalas/days-scales`,
      param,
      { headers: this.authService.userToken() }
    );
  }

  verifyProfessionalDisponibility({ professional_id, scales }) {
    return this.http.post(
      `${URL_GLOBAL}/newescalas/check-disponibility/${professional_id}`,
      { scales },
      { headers: this.authService.userToken() }
    );
  }
  getTranscriptionsOfContractId(contract_id: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/transcriptions-monitoring?contract_id=${contract_id}`,
      { headers: this.authService.userToken() }
    );
  }

  getDataFromServiceDashboard({ tab, query }: DashboardServiceRequestParams) {
    const links = {
      general: `${URL_WEB}/scales/dashboard/general`,
      client: `${URL_WEB}/scales/dashboard/clients`,
      professional: `${URL_WEB}/scales/dashboard/professionals`,
    };

    const url = `${links[tab]}${query ? `?start_date=${query.start_date}&end_date=${query.end_date}` : ''
      }`;

    return this.cacheService.callHttpRequestWithCache({
      url,
      isAuthenticated: true,
      timeInMinutes: 30,
    });
  }

  getProvidersOfScale(param): Observable<any[]> {
    return this.http.get<any[]>(`${URL_WEB}/provider-scale?contract_id=${param.contract_id}&dateStart=${param.dateStart}&dateEnd=${param.dateEnd}`, { headers: this.authService.userToken() });
  }
}
